import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['filesNames', 'input', 'fileBlock', 'deleteLink']
  static values = {
    langage: String
  }

  connect() {
    this.element.controller = this
  }

  select() {
    event.preventDefault()
    this.inputTarget.click()
  }

  get translation() {
    return this.langageValue === 'en' ? 'files' : 'fichiers'
  }

  change() {
    const files = Array.from(this.inputTarget.files)
    this.filesNamesTarget.innerHTML = files.map(file => `<li>${file.name}</li>`).join('')
  }
}
